
import Vue from 'vue';
import { CvDropdown, CvDropdownItem } from '@carbon/vue';
export default Vue.extend({
  name: 'DropDown',
  components: {
    CvDropdown,
    CvDropdownItem,
  },
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      default() {
        return '';
      },
    },
  },
  methods: {
    log: console.log,
  },
});
